import React from 'react';
import PropTypes from 'prop-types';
import { map, get } from 'lodash';
import { Row, Column, Icon, Text } from '../../../../../../components/common';
import { cleanOrderId } from '../../../../../../utils/misc';
import { ARGENT, DARK_CHARCOAL } from '../../../../../../utils/colors';

export const GroupOrdersTabsHeader = ({ tabs, activeTab, setActiveTab }) => {
    return (
        <Row 
            style={{ 
                borderBottom: '1px solid #e8e8e8',
                marginBottom: '20px'
            }}
        >
            {map(tabs, ({ key, icon, color, orderData }) => (
                <Column
                    key={key}
                    padding={12}
                    align='center'
                    justify='center'
                    borderBottom={activeTab === key ? `3px solid #a4c735` : `1px solid ${ARGENT}`}
                    onClick={() => setActiveTab(key)}
                    pointer
                    style={{ 
                        flex: 1,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                    }}
                >
                    <Row align='center' gap={8}>
                        <Icon 
                            name={icon}
                            color={activeTab === key ? color : ARGENT}
                            size={16}
                        />
                        <Text 
                            text={cleanOrderId(get(orderData, 'id'))} 
                            size={14} 
                            strong={activeTab === key}
                            color={activeTab === key ? DARK_CHARCOAL : ARGENT}
                        />
                    </Row>
                </Column>
            ))}
        </Row>
    );
};

GroupOrdersTabsHeader.propTypes = {
    tabs: PropTypes.array.isRequired,
    activeTab: PropTypes.string.isRequired,
    setActiveTab: PropTypes.func.isRequired
};